import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { ParagraphPartnersHighlights as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphPartnersHighlightsProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphPartnersHighlights: React.FC<ParagraphPartnersHighlightsProps> = ({ entity }) => {
  const paragraph = entity.toJS();
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.value;

  return (
    <div className="Paragraph ParagraphPartnersHighlights">
      {title && <h2>{title}</h2>}
      {body && (
        <WysiwygField
          html={body}
          className="ParagraphPartnersHighlights__body"
        />
      )}
      <View
        id="partners"
        display="highlights"
      />
    </div>
  );
};

export default ParagraphPartnersHighlights;
